import React, { useState } from 'react';
import { Field } from 'redux-form';
import { HorizontalFormControl } from '../../../../common/components';
import { FormGroupInput } from '../../../../common/form/components/components';
import CheckboxUnlabeled from '../../../../common/components/ReduxFormField/CheckboxUnlabeled';
import { required } from 'redux-form-validators';
import InfoButton from '../../../../common/components/InfoButton';
import { SelectField } from '../../../../common/components/ReduxFormField';

const isRequired = required({ message: 'This field is required' });

const isAlphaNumeric = (value) =>
  value && /[^a-zA-Z0-9]/i.test(value)
    ? 'Only alphanumeric characters allowed and please contact Socrates for custom URLs.'
    : undefined;

export const WhiteLabelSummary = ({ hasWhiteLabel, customDomain, isTrackingLink }) => {
  const [domain, setDomain] = useState('.justtravelcover.com');

  const handleDefaultChannel = (option) => {
    if (option?.value === 'aneevo-b2c') {
      setDomain('.aneevo.com');
    }
  };

  return (
    <>
      {!hasWhiteLabel && (
        <>
          {customDomain ? (
            <Field
              name="meta.url"
              type="url"
              label="URL"
              labelSize={3}
              component={HorizontalFormControl}
              validate={[isRequired, isAlphaNumeric]}
            />
          ) : (
            <Field
              name="meta.url"
              label="Sub domain"
              labelSize={4}
              colSize={8}
              component={FormGroupInput}
              validate={[isRequired, isAlphaNumeric]}
              cleaveOptions={{ lowercase: true }}
              addOnAfter={domain}
            />
          )}
          <Field
            name="meta.custom_domain"
            label="Set custom domain"
            labelSize={4}
            component={CheckboxUnlabeled}
            options={[{ label: '', value: true }]}
          />
        </>
      )}
      <Field
        name="meta.welcome_page"
        label="Enable welcome page"
        labelSize={4}
        component={CheckboxUnlabeled}
        options={[{ label: '', value: true }]}
      />
      {!isTrackingLink && !hasWhiteLabel && (
        <>
          <Field
            name="meta.default_channel"
            component={SelectField}
            infoButton={
              <InfoButton
                content={
                  'Please select the default theme for the WL, once created you can still customise as needed within the White Label Editor.'
                }
              />
            }
            label="White Label Theme"
            labelSize={4}
            options={[
              {
                label: 'Aneevo',
                value: 'aneevo-b2c',
              },
              {
                label: 'Just Travel',
                value: 'jtc-whitelabel-b2c',
              },
            ]}
            handleOnChange={handleDefaultChannel}
          />
        </>
      )}
    </>
  );
};
